import { MenuItem } from "@mui/material";
import { saveAs } from "file-saver";
import {
  gridFilteredSortedRowIdsSelector,
  gridVisibleColumnFieldsSelector,
  useGridApiContext,
} from "@mui/x-data-grid";
import * as React from "react";
//import dayjs from "dayjs";

const ExcelJS = require("exceljs");

// Get data on grid
const getExcelData = (apiRef) => {
  // Select rows and columns
  const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
  const visibleColumnsField = gridVisibleColumnFieldsSelector(apiRef);

  // Format the data. Here we only keep the value
  const data = filteredSortedRowIds.map((id) => {
    const row = {};
    visibleColumnsField.forEach((field) => {
      row[field] = apiRef.current.getCellParams(id, field).value;
    });
    return row;
  });

  return data;
};

//Init header columns
const initHeaderColumns = (headers) => {
  let headerColumns = [];
  headers.forEach((h) => {
    let headerColumn = { key: h, width: 10 };
    headerColumns.push(headerColumn);
  });
  return headerColumns;
};

const Danhmucxetuyendienexcel = function Danhmucxetuyendienexcel() {
  const apiRef = useGridApiContext();
  const data = getExcelData(apiRef);
  // Auto Width
  const autoWidth = (worksheet, minimalWidth) => {
    worksheet.columns.forEach((column) => {
      let maxColumnLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        maxColumnLength = Math.max(
          maxColumnLength,
          minimalWidth,
          cell.value ? cell.value.toString().length : 0
        );
      });
      column.width = maxColumnLength + 2;
    });
  };

  const handleExport = async () => {
    // Init workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("My Sheet");

    // Title
    sheet.mergeCells(1, 1, 1, Object.keys(data[0]).length);
    sheet.getCell("A1").value = "DANH MỤC TUYẾN XE ĐIỆN";

    // Init header columns at row 2 on excel file
    var headerValues = [];
    for (const element of Object.keys(data[0])) {
      if (element == "stt") {
        headerValues.push("STT");
      } else if (element == "matuyen") {
        headerValues.push("Mã tuyến");
      } else if (element == "tentuyen") {
        headerValues.push("Tên tuyến");
      } else if (element == "diemdau") {
        headerValues.push("Điểm đầu");
      } else if (element == "diemcuoi") {
        headerValues.push("Điểm cuối");
      } else if (element == "culy") {
        headerValues.push("Cự ly");
      } else if (element == "lotrinh") {
        headerValues.push("Lộ trình");
      } else if (element == "tinhtrang") {
        headerValues.push("Tình trạng");
      }
    }

    sheet.getRow(2).values = headerValues;
    sheet.columns = initHeaderColumns(Object.keys(data[0]));

    // Fullfill data for excel file
    sheet.addRows(data);

    // Design excel
    // Auto column width for excel file with default 10px
    autoWidth(sheet, 10);

    // Design Border and Common Alignment + Font
    sheet.eachRow(function (row) {
      row.eachCell({ includeEmpty: true }, function (cell) {
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        cell.alignment = {
          vertical: "middle",
          horizontal: "left",
          wrapText: true,
        };
        cell.font = {
          name: "Times New Roman",
          size: 13,
        };
      });
    });

    // Design Title
    sheet.getCell("A1").font = {
      bold: true,
      name: "Times New Roman",
      size: 13,
    };
    sheet.getCell("A1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };

    // Design header
    const row2 = sheet.getRow(2);
    row2.eachCell(function (cell) {
      if (cell.value) {
        cell.font = {
          bold: true,
          name: "Times New Roman",
          size: 13,
        };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };
      }
    });

    // Design special Columns

    // Write excel file
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs.saveAs(new Blob([buffer]), "Danhmucxetuyendienexcel.xlsx");
  };

  return (
    <MenuItem
      onClick={() => {
        if (data[0]) {
          handleExport();
        }
      }}
    >
      Download Excel
    </MenuItem>
  );
};

export default Danhmucxetuyendienexcel;
